
import { Lavorazione } from '../models/lavorazione';
import { Persona } from '../models/persona';
import { Articolo } from '../models/articolo';

export class Richiestaordinazionearticolo {
    Id: number;
    Datarichiesta: Date;
    Dataordine: Date;
    Dataconsegna: Date;
    Quantitarichiesta: number;
    Quantitaordinata: number;
    Quantitaconsegnata: number;
    Lavorazione: Lavorazione;
    Persona: Persona;
    Articolo: Articolo;

  constructor(){
    this.Id=0;
    this.Datarichiesta=null;
    this.Dataordine=null;
    this.Dataconsegna=null;
    this.Quantitarichiesta=0;
    this.Quantitaordinata=0;
    this.Quantitaconsegnata=0;
    this.Lavorazione=undefined;
    this.Persona=undefined;
    this.Articolo=undefined;

  }
}
